// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0c2e357a","453":"35ed8e0a","667":"9e663ff0"}[chunkId] + ".chunk.js";
};